module.exports = __webpack_public_path__ + "prod/1.42.2/img/xtrh_two.c0333127.png";